import { useParams } from 'react-router';
import { type RouteParams } from '../../../util/routes';
import { useUpdateMap } from '../../../service/requests';
import { type Marker } from '../../../util/types';
import { type Response } from '../../../service/response';

export const useUpdateMarkers = (markers: Marker[]): any => {
  const { mapId } = useParams<RouteParams<'viewMap'>>();
  const { updateMap } = useUpdateMap(mapId!);
  const updateMarkers = (): Response<{ mapId: string }, Error> => {
    return updateMap({ markers });
  };

  return {
    updateMarkers,
  };
};
